import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get} from "@utils/axios_api";
import { qk } from "@utils/queryKey";
import { downloadExcel } from "@utils/downloadExcel";

const fetchInvoiceList = async (params) => {
  const response = await get("/admin/invoice/invoiceList", { params });
  return response;
};


export function useInvoice() {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      sourceType: "",
      catgRegYear: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const sourceType = searchParams.get("sourceType") || "";
  const catgRegYear = searchParams.get("catgRegYear") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd, searchWrd,  sourceType, catgRegYear,
    pageIndex, recordCountPerPage,
  };

  const { data, refetch } = useQuery({
    queryKey: [...qk.invoiceAllList(), JSON.stringify(queryParam)],
    queryFn: () => fetchInvoiceList(queryParam),
    keepPreviousData: true,

  });


  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("sourceType", values.sourceType || "");
    newParams.set("catgRegYear", values.catgRegYear || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    methods.reset({
      searchCnd: "",
      searchWrd: "",
      sourceType: "",
      catgRegYear: "",
    });
    setSearchParams(new URLSearchParams());
  };
  
  const handleExcelDownload = (e) => {
    e.preventDefault();
    downloadExcel({
      url: "/admin/invoice/invoiceListAllExcelDown",
      params: queryParam,
      filePrefix: "교육세금계산서",
    });

  }


  return {
    methods, data,
    onSubmit,
    handlePageChange, handleExcelDownload, resetSearch,
    pageIndex, recordCountPerPage,
    refetch, refreshList,
  };
}
